// extracted by mini-css-extract-plugin
export default {"tile":"rTbjG","side-scroll":"eoC9i","grid":"veWvn","selected":"gRxnj"};